/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';
import { Resizable } from 're-resizable';

import { Modal } from 'ui/components/styled';
import { SidebarWidth } from 'ui/components/styled/Sidebar';
import { ContainerStyle } from 'ui/components/styled/Modal';

export const ResizableModal = React.forwardRef((props, ref) => {
  const maxWidth = React.useMemo(() => window.innerWidth - SidebarWidth - 40, [window.innerWidth]); // 40 == left + right margin

  return (
    <Modal
      ref={ref}
      containerComponent={Container}
      //maxWidth={`calc(100% - ${SidebarWidth}px - 40px)`}
      maxWidth={`${maxWidth}px`}
      {...props}
    />
  );
});

const Container = styled(
  // eslint-disable-next-line no-unused-vars
  React.forwardRef(({ position, adjustPosition, style = {}, ...rest }, ref) => (
    <Resizable
      ref={(component) => (ref.current = component?.resizable)}
      defaultSize={{ width: rest.width, height: 'auto' }}
      style={{ ...style, position: 'absolute' }}
      enable={{ left: true, right: true }}
      {...rest}
    />
  ))
)`
  ${ContainerStyle}
`;
